import { useRouter } from 'next/router'
import useNavigation from 'src/lib/hooks/useNavigation'
import { DiamondsFour, Gear, MoneyWavy, Question } from '@phosphor-icons/react'
import { classNames } from 'src/lib/utils/helpers'
import { isPathActive } from 'src/lib/utils/path-matching'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'
import { Icon, Tooltip, TooltipContent, TooltipTrigger } from '@shopflo/ui'
import { motion } from 'motion/react'

const ClosedNavFooter = () => {
  const tooltipLabels: Record<string, string> = {
    'support': 'Help & Support',
    'settings': 'Settings',
    'apps-store': 'Apps & Integrations',
    'invoices': 'Billing'
  }
  const router = useRouter()
  const {
    actions: { toggleAndRedirect }
  } = useNavigation()
  const { canAccess, isUserConfigured } = useUser()

  const navItems = [
    {
      icon: DiamondsFour,
      path: '/apps-integrations',
      exact: false,
      permissionId: "TAB_APP_STORE",
      disabled: !canAccess(permissionType.TAB_APP_STORE, 0) || !isUserConfigured ,
      id: "apps-store"
    },
    {
      icon: MoneyWavy,
      path: '/billing',
      exact: false,
      permissionId: 'TAB_INVOICES',
      disabled: !canAccess(permissionType.TAB_INVOICES, 0) || !isUserConfigured,
      id: 'invoices'
    },
    {
      icon: Question,
      path: '/support',
      exact: true,
      permissionId: 'TAB_SUPPORT',
      disabled: !canAccess(permissionType.TAB_SUPPORT, 0) || !isUserConfigured,
      id: 'support'
    },
    {
      icon: Gear,
      path: '/settings',
      exact: false,
      permissionId: 'TAB_SETTINGS',
      disabled: !canAccess(permissionType.TAB_SETTINGS, 0) || !isUserConfigured,
      id: 'settings'
    }
  ]

  return (
    <motion.div
      className='h-full w-full p-2 flex flex-col gap-2 items-start'
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      {navItems.map(item => {
        const isActive = isPathActive(router.pathname, item.path, item.exact)
        const isDisabled = item.disabled

        return (
          <Tooltip key={item.path} delayDuration={0}>
            <TooltipTrigger asChild>
              <div
                className={classNames(
                  'flex justify-center w-9 items-center rounded-md py-1 px-2',
                  isActive ? 'bg-white' : '',
                  isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-black/5 cursor-pointer'
                )}
                id={item.id}
                onClick={() => !isDisabled && toggleAndRedirect(item.path)}
              >
                <Icon IconComponent={item.icon} size='sm' className='text-zinc-600' />
              </div>
            </TooltipTrigger>
            <TooltipContent side='right' sideOffset={1}>
              {tooltipLabels[item.id] ?? ''}
            </TooltipContent>
          </Tooltip>
        )
      })}
    </motion.div>
  )
}

export default ClosedNavFooter
